import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { ApiEvsService } from "app/common/services/ApiEvs.service";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Headers, Http } from "@angular/http";

@Injectable()
export class LinkLoyaltyService {
  headers: Headers;
  url = environment.api_evs;
  url2 = environment.api_evs + "/qr-core-aps";

  constructor(private http: Http, private apiEvsService: ApiEvsService) {
    const token = localStorage.getItem("Access-Token");
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      "Content-Type": "application/json",
      Authorization: `${token}`,
    });
  }

  checkPhone(phone): Observable<any> {
    return this.http
      .get(`${this.url}/saleout/check_phone?phone=${phone}&systemType=${1}`, {
        headers: this.headers,
      })
      .map((res: any) => res.json())
      .catch((err: any) => {
        throw this.apiEvsService.checkErr(err);
      });
  }
  verifyOTP(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/saleout/verify_otp_linked`, body, {
        headers: this.headers,
      })
      .map((res: any) => res.json())
      .catch((err: any) => {
        throw this.apiEvsService.checkErr(err);
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/linkLoyalty/services/linkLoyalty.service.ts